import { I18n } from "i18n-js";
import translations from "../locales.json";

// Force recompile
const userLocale = gon.global.locale;

export const i18n = new I18n();
i18n.store(translations);
i18n.defaultLocale = userLocale;
i18n.enableFallback = true;
i18n.fallbacks = true
i18n.locale = userLocale;

i18n.locales.register('es_gtm', ['es']);
i18n.locales.register('es_gtm_lsg', ['es_lsg', 'es_gtm', 'es_slv', 'es']);
i18n.locales.register('es_hnd', ['es']);
i18n.locales.register('es_hnd_lsg', ['es_lsg', 'es_hnd', 'es_slv', 'es']);
i18n.locales.register('es_nic', ['es']);
i18n.locales.register('es_nic_lsg', ['es_lsg', 'es_nic', 'es_slv', 'es']);
i18n.locales.register('es_pan', ['es']);
i18n.locales.register('es_pan_lsg', ['es_lsg', 'es_pan', 'es']);
i18n.locales.register('es_pry', ['es']);
i18n.locales.register('es_pry_lsg', ['es_lsg', 'es_pry', 'es_slv', 'es']);
i18n.locales.register('es_slv', ['es']);
i18n.locales.register('es_slv_lsg', ['es_lsg', 'es_slv', 'es']);
